/**
 * Modal system constants — single source of truth for all modal colors,
 * z-indices, animation springs, and utility functions.
 */

export const MODAL_COLORS = {
  surface: 'var(--user-page-card-bg)',
  header: 'var(--user-page-accent)',
  interactive: 'color-mix(in srgb, var(--user-page-card-border) 30%, var(--user-page-card-bg))',
  border: 'var(--user-page-card-border)',
  shadow: 'rgba(0,0,0,0.12)',
  text: 'var(--user-page-text)',
  warning: '#f59e0b',
  success: '#10b981',
  danger: '#ef4444',
} as const;

export const Z_INDEX = {
  stackLayer: 50,
  stackScrim: 51,
  sideDrawerEdge: 89,
  sideDrawerBackdrop: 90,
  sideDrawer: 91,
  mobileBackdrop: 100,
  mobileModal: 101,
  desktopBackdrop: 110,
  desktopModal: 111,
  vinylOverlay: 9998,
  particles: 9999,
  resultIcon: 10000,
} as const;

export const SPRING = {
  drawer: { type: 'spring' as const, damping: 25, stiffness: 200 },
  bottomSheet: { type: 'spring' as const, damping: 30, stiffness: 300 },
  card: { type: 'spring' as const, damping: 25, stiffness: 300 },
  sideDrawer: { type: 'spring' as const, stiffness: 300, damping: 30 },
  stackTransition: { type: 'spring' as const, stiffness: 300, damping: 30 },
} as const;

export const VINYL_SIZE = 180;

export { triggerHapticFeedback } from '@/utils/haptics';
